import { controls } from "../../controls";

const rp906 = {
  label: "Cash Credit Statement",
  pageLabel: "Cash Credit Statement",
  starting: true,
  url: "rp906",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "Taluka", width: "col-sm-2" }),
    ...controls.Taluka({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "taluka_display", name: "taluka_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "filter", label: "As on Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", isRequired: true, width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-3 " }),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter' }),
  ],

  //form: [
  //  ...controls.displayText({ label: "Crop Type Code", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //  ...controls.displayText({ label: "Crop Type Desc", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type_display", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //],
  form: [],

  history: {
    perPage: 10,
    reportHeader: "Cash Credit Statement From-to",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Head Details",
        accessor: "head_details_code",
        width: 180,
        rwidth: 100
      },

      {
        Header: "Opening",
        accessor: "opening_bal",
        type: "currency",
        width: "*",
        rwidth: "*"
      },

      {
        Header: "Advance",
        accessor: "advance_code",
        type: "currency",
        width: "*",
        rwidth: "*"
      },

      {
        Header: "Recovery",
        accessor: "recovery_code",
        type: "currency",
        width: "*",
        rwidth: "*"
      },
      {
        Header: "Outstanding",
        accessor: "outstanding_code",
        type: "currency",
        width: "*",
        rwidth: "*"
      },
      {
        Header: "Overdue",
        accessor: "overdue_code",
        type: "currency",
        width: "*",
        rwidth: "*"
      },
      {
        Header: "Demand",
        accessor: "demand_code",
        type: "currency",
        width: "*",
        rwidth: "*"
      },

    ]
  }
};

export default rp906;